import { Component, Vue } from 'vue-property-decorator'
@Component({ name: 'PasswordChangPage' })
export default class PasswordChangPage extends Vue {
  created () {
    //
  }

  private onOkClick () {
    alert('修改成功')
  }

  private onCancelClick () {
    this.$router.push('/')
  }
}
